// eslint-disable-next-line import/no-anonymous-default-export
export default (loading = false, action) => {
  switch (action.type) {
    case "USERS_LOADING":
      return action.payload;
    default:
      return loading;
  }
};
